import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import Moment from 'moment';

export const baseURI = '/configuracion/estados-de-tramite';

/**
 * GET EstadosDeTramite
 * @param {Object} params
 * @returns {Promise<Array<object>>}
 */
export const getEstadosDeTramite = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET EstadoDeTramite
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getEstadoDeTramite = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST EstadoDeTramite
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postEstadoDeTramite = async (values) => {
  try {
    const valuesEntidad = values;
    valuesEntidad.entidad = 1;
    const response = await API.post(baseURI, valuesEntidad);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH EstadoDeTramite
 * @param {number} id
 * @param {object} _values
 * @returns {Promise<object|boolean>}
 */
export const patchEstadoDeTramite = async (id, _values) => {
  try {
    const values = {
      ..._values,
      fecha_de_ultimo_movimiento: Moment(),
    };
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
/**
 * DELETE EstadoDeTramite
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteEstadoDeTramite = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}/`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
